/**
 * aiMonitor模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const aiForecastDataPoint = {
  //查询时间范围
  queryTimeHorizon(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/aiForecastDataPoint/queryTimeHorizon`, param);
  },
  //查询应用数据点
  checkApplicationDataPointStatistics(params) {
    return $http.post(`${global.API_URL}/sme/aiForecastDataPoint/checkApplicationDataPointStatistics`, params);
  }
}

export default aiForecastDataPoint;



// WEBPACK FOOTER //
// ./src/api/aiForecastDataPoint.js